export default __webpack_public_path__ + "static/media/icon_close_indicators.b162db71.svg";